import { getToppingsIdFromProducts, type IProduct } from '@entities/product';
import { type IPromotionCatalog } from '@entities/promotion';
import type { FetchLoaderType } from '@shared/lib/routing';
import { type ISeoPage } from '@widgets/seoPage';
import globalStore from 'modules/global-store';

type Params = {
  city: string;
  menu: string;
};

export const productListPageLoader = async (
  fetch: FetchLoaderType,
  { params, lang }: { params: Params; lang: string },
  { store }: { store: typeof globalStore },
) => {
  const { city, menu } = params;

  const [seoPage, productList, catalogPromotions] = await Promise.all([
    fetch<ISeoPage>({
      url: '/seo/page',
      params: { url: `/menu/${menu}`, city, lang },
    }),
    fetch<{ product: IProduct[] }>({
      url: '/product/get_list',
      params: { menu, city, lang },
    }),
    fetch<{ stock: IPromotionCatalog[] }>({
      url: '/stock/catalog',
      params: { city, lang },
    }),
  ]);
  const result = {
    seoPageData: seoPage.data,
    productList: productList.data.product,
    catalogPromotions: catalogPromotions.data.stock,
    wokToppings: undefined,
  };

  const wokBox = productList.data.product.find(
    (p) => p?.product_type?.name === 'wok',
  );
  if (wokBox) {
    const allToppingIds = getToppingsIdFromProducts([wokBox]) || [];
    if (allToppingIds.length) {
      const wokToppings = await fetch<{ product: IProduct[] }>({
        url: '/product/index',
        params: { city, lang, id: allToppingIds },
      });
      return { ...result, wokToppings: wokToppings.data.product };
    }
  }
  const storedProducts = store.get('products') || {};
  const updatedProducts = result.productList.reduce(
    (acc, product) => ({ ...acc, [product.id]: product }),
    storedProducts,
  );
  store.set('products', updatedProducts);
  return result;
};
